import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, endDate, filters) => {
        const params = {
            ci_class: filters.ciClass.join(','),
            operable: filters.operable,
            state:    filters.state
        };

        if (filters.state === 'all') {
            Object.assign(params, {
                start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
                end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY)
            });
        }

        return params;
    },
    ...storeModuleFactory({
        name:               'monitoringClientsIdClasses',
        endpoint:           endpoints.monitoring.clientsIDClasses,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: results => ({
            total:   results.total,
            CIClass: !results.ci_class ? [] : results.ci_class.map(item => ({
                name:     item.ci_class,
                totalCIs: item.total_events,
                y:        item.total_events
            }))
        })
    })
};




// WEBPACK FOOTER //
// ./src/modules/store/monitoringClientsIdClasses.js